import { useState } from "react";
import { ihinFaqs as faqs } from "@/data/faqs";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            FAQ
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            <span className="text-primary-500">よくあるご質問</span>
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((f, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={f.q}
                className="border border-background-200 rounded-lg bg-background-50 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer hover:bg-background-100 transition-colors"
                >
                  <span className="text-sm md:text-base font-bold text-foreground-900">
                    {f.q}
                  </span>
                  <span className="w-8 h-8 flex items-center justify-center shrink-0">
                    <i
                      className={`text-primary-600 text-xl transition-transform ${
                        isOpen ? "ri-subtract-line" : "ri-add-line"
                      }`}
                    ></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 md:px-6 pb-5">
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      {f.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}